<template>
  <FilterBadge v-bind="{ ...$props, ...$attrs }">
    <i class="fas fa-clock mr-1" />
    {{ text }}
  </FilterBadge>
</template>

<script setup lang="ts">
import { computed, type PropType } from "vue";
import { useTranslation } from "@/language/translation";
import { LISA_DATE_SHORT } from "@/language/translation";
import DateFilter from "../../filterImplementations/DateFilter";
import FilterBadge from "./FilterBadge.vue";

const props = defineProps({
  filter: {
    type: Object as PropType<DateFilter>,
    required: true,
  },
});
const { locale } = useTranslation();
const text = computed(() => {
  return props.filter.date
    .map((d) => {
      if (d == null) {
        return "∞";
      }
      return d.toLocaleString(LISA_DATE_SHORT, { locale: locale.value });
    })
    .join(" ﹣ ");
});
</script>

<style lang="scss" scoped></style>
